import { DeliveryInGroup } from "../../../types/schedule/delivery-in-group";
import { DeliveryInGroupDto } from "../../../types/schedule/delivery-in-group-dto";
import { ScheduleDto } from "../../../types/schedule/schedule-dto";
import { convertActionDtoToAction } from "../action/action-converter";
import { convertLoadDtoToLoad } from "../load/load-converter";
import { convertLocationDtoToLocation } from "../location/location-converter";
import { convertCompanyDtoToCompany } from "../user/company-convertor";
import { convertUserDtoToUser } from "../user/user-converter";
import { convertWorkPlaceDtoToWorkPlace } from "../work-place/work-place-converter";

export const convertDeliveryInGroupDtoToDeliveryInGroup = (
  deliveryInGroupDto: DeliveryInGroupDto,
  scheduleDto: ScheduleDto
): DeliveryInGroup => {
  return {
    id: deliveryInGroupDto.id,
    status: deliveryInGroupDto.status,
    scheduleId: deliveryInGroupDto.scheduleId,
    dateToWork: deliveryInGroupDto.dateToWork,
    inProgressLocation: convertLocationDtoToLocation(
      deliveryInGroupDto.inProgressLocation
    ),
    inProgressWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryInGroupDto.inProgressWorkPlace
    ),
    inProgressAction: convertActionDtoToAction(
      deliveryInGroupDto.inProgressAction
    ),
    pairLocation: convertLocationDtoToLocation(deliveryInGroupDto.pairLocation),
    pairWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryInGroupDto.pairWorkPlace
    ),
    pairAction: convertActionDtoToAction(deliveryInGroupDto.pairAction),
    invoiceNumber: deliveryInGroupDto.invoiceNumber,
    load: convertLoadDtoToLoad(deliveryInGroupDto.load),
    comment: deliveryInGroupDto.comment,
    client: convertCompanyDtoToCompany(deliveryInGroupDto.client),
    agency: convertCompanyDtoToCompany(deliveryInGroupDto.agency),

    worker: scheduleDto.worker
      ? convertUserDtoToUser(scheduleDto.worker)
      : undefined,
    scheduleAlias: scheduleDto.alias,
  };
};
